import { render, staticRenderFns } from "./ShopeePayContent.vue?vue&type=template&id=481dd506&scoped=true"
import script from "./ShopeePayContent.vue?vue&type=script&lang=js"
export * from "./ShopeePayContent.vue?vue&type=script&lang=js"
import style0 from "./ShopeePayContent.vue?vue&type=style&index=0&id=481dd506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481dd506",
  null
  
)

export default component.exports